module.exports=function(n){return n>=0&&n<2?"one":"other"}